import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DOCTOR_API, PATIENT_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: data,
});
export const image = (image: any) => ({
    type: 'FETCH_IMG_SUCCESS',
    payload: image,
});




export const fetchPatientProfileData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = PATIENT_API.patientprofile_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const apiname = PATIENT_API.patientProfile_API;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(image(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};